var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#copy_28-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.06 5.2C14.105 5.086 15.42 5 17 5c1.581 0 2.895.086 3.941.2.968.106 1.097.141 1.34.29.051.03.177.129.322.291.145.162.23.297.255.352.115.244.142.44.142 1.66v6.414c0 1.22-.027 1.416-.142 1.66-.025.055-.11.19-.255.352-.145.162-.27.26-.322.292-.243.148-.372.183-1.34.289a31.73 31.73 0 0 1-.94.088v-3.265c0-.968.002-1.85-.427-2.764a4.623 4.623 0 0 0-.738-1.081 4.622 4.622 0 0 0-.994-.85c-.86-.525-1.626-.608-2.462-.698l-.114-.012A39.445 39.445 0 0 0 11 8v-.207c0-1.22.028-1.416.142-1.66.026-.055.11-.19.256-.352.145-.162.27-.26.322-.292.243-.148.371-.183 1.34-.289ZM8 8.104v-.481c-.001-.968-.003-1.85.426-2.764.188-.4.467-.778.738-1.081.272-.303.617-.62.995-.85.86-.525 1.626-.608 2.462-.698l.113-.012A39.445 39.445 0 0 1 17 2c1.69 0 3.112.092 4.266.218l.114.012c.836.09 1.602.173 2.462.697.377.23.723.548.994.851.272.303.55.68.738 1.08.43.915.428 1.797.426 2.766V14.377c.002.968.003 1.85-.426 2.764-.187.4-.466.778-.738 1.081a4.62 4.62 0 0 1-.994.85c-.86.525-1.627.608-2.463.698l-.114.012c-.39.043-.812.081-1.265.114v.481c.002.968.003 1.85-.426 2.764-.187.4-.466.778-.738 1.081-.271.303-.617.62-.994.85-.86.525-1.626.608-2.462.698l-.114.012A39.449 39.449 0 0 1 11 26c-1.69 0-3.112-.092-4.266-.218l-.113-.012c-.836-.09-1.602-.173-2.462-.697a4.621 4.621 0 0 1-.995-.851 4.622 4.622 0 0 1-.738-1.08C1.997 22.226 2 21.344 2 20.375V13.623c-.001-.968-.003-1.85.426-2.764.188-.4.467-.778.738-1.081.272-.303.617-.62.995-.85.86-.525 1.626-.608 2.462-.698l.113-.012c.391-.043.814-.082 1.266-.114Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy_28-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy28);
export default __webpack_public_path__ + "static/media/copy_28.0452fc48.svg";
export { ForwardRef as ReactComponent };